import { Component, ElementRef, ViewChild } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { Environment } from "app/decorators/environment.decorator";
import { SnackBarService } from "app/services/snackbar.service";
import * as moment from "moment";
import { Observable, Subject } from "rxjs";
import {
    debounceTime,
    distinctUntilChanged,
    map,
    startWith,
    takeUntil,
} from "rxjs/operators";
import { UnregisteredScheduleService } from "../unregistered-schedule/unregistered-schedule.service";
import { ScheduleService } from "./schedule.service";
import { ProfileService } from "../profile/profile.service";
import { fuseAnimations } from "@fuse/animations";
import { WaitingListComponent } from "./components/waiting-list/waiting-list.component";
import { PageOptions } from "../interface/pageOptions";
import { Schedule } from "../interface/schedule";
import { SelectProcedureComponent } from "../unregistered-schedule/select-procedure/select-procedure.component";

export interface Historico {}

@Component({
    selector: "schedule",
    templateUrl: "./schedule.component.html",
    styleUrls: ["./schedule.component.scss"],
    animations: fuseAnimations,
})
export class ScheduleComponent {
    performerPageOptions: PageOptions;
    procedurePageOptions: PageOptions;
    specialityPageOptions: PageOptions;
    insurancePageOptions: PageOptions;
    schedulePageOptions: PageOptions;
    qtdScheduleList: number = 0;
    showProfessional: any;
    unitControl = new FormControl("", Validators.required);
    specialityControl = new FormControl("", Validators.required);
    insuranceControl = new FormControl("", Validators.required);
    professionalControl = new FormControl("");
    procedureControl = new FormControl("", Validators.required);
    dateControl = new FormControl("", Validators.required);
    hourControl = new FormControl("", Validators.required);
    selectFormControl = new FormControl("", Validators.required);
    prepareProcedureControl = new FormControl("");
    observableControl = new FormControl("");
    loadingSchedule = false;
    displayedColumns: string[] = [
        "dataAgenda",
        "nomeUnidade",
        "grupoProcedimento",
    ];
    dataSource = [];

    groupedSchedules: any[];

    unitList: any;

    specialityList = [];
    insuranceList = [];
    dateList = [];
    availableDates: any;
    dateClass: any;

    professionalList = new Array();
    professionalEspecialidade = [];
    procedureList = [];
    hourList = [];

    filteredProcedure: Observable<string[]>;

    newSchedule: boolean = false;
    paciente: any;
    parameters: any;
    unity: any;
    unityValue: any;
    scheduleList = [];
    schedule: any;
    currentDate: string;
    enterprise: any;
    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;

    info: boolean = false;
    obsEnterprise: any;
    //tabela
    totalElements = 0;
    pagina = 0;
    tamanho = 0;

    private _unsubscribeAll: Subject<any>;
    @ViewChild("scheduleContainer") scheduleContainer!: ElementRef;

    constructor(
        private readonly scheduleService: ScheduleService,
        private unregisteredSscheduleService: UnregisteredScheduleService,
        private profileService: ProfileService,
        private progressBar: FuseProgressBarService,
        private snackBar: SnackBarService,
        private router: Router,
        public _matDialog: MatDialog
    ) {
        this._unsubscribeAll = new Subject();

        this.insurancePageOptions = new PageOptions();
        this.specialityPageOptions = new PageOptions();
        this.specialityPageOptions.fieldSort = "name";
        this.performerPageOptions = new PageOptions();
        this.procedurePageOptions = new PageOptions();
        this.schedulePageOptions = new PageOptions();
    }

    async ngOnInit() {
        this.paciente = JSON.parse(localStorage.getItem("paciente"));
        this.parameters = JSON.parse(localStorage.getItem("enterprise"));

        if (this.paciente?.idConvenio) {
            this.getInsuranceById(this.paciente.idConvenio);
        }

        this.showProfessional = this.parameters.showProfessional;

        if (!this.paciente) {
            this.router.navigate(["auth/login"]);
        } else {
            this.paciente = await this.profileService.buscar(
                this.paciente.idPaciente
            );
            await this.getList();
            this.setObsEnterprise();
            this.initializeObservables();
        }

        this.specialityControl.valueChanges.subscribe(() => {
            this.clearSchedules();
            this.professionalControl.setValue(null);
        });

        this.professionalControl.valueChanges.subscribe(() => {
            this.clearSchedules();
        });
    }

    clearSchedules(): void {
        this.groupedSchedules = [];
    }

    onUnityChange() {
        this.clearSchedules();
        this.specialityControl.setValue(null);
        this.professionalControl.setValue(null);
        this.getSpecially();
    }

    toggleHistory() {
        this.newSchedule = !this.newSchedule;
        this.clearSchedules();
    }

    setObsEnterprise() {
        setTimeout(() => {
            this.enterprise = JSON.parse(localStorage.getItem("enterprise"));
            let obs = this.enterprise.obsAgendaOnline;
            obs
                ? (this.obsEnterprise = obs.split("¿"))
                : (this.obsEnterprise = Array("Sem informativo"));
        }, 500);
    }

    initializeObservables() {
        this.observableProfessional();
        this.observableSpeciality();
        this.observableInsurance();
        this.observableDateControl();
        this.observableProcedure();
        this.observableHourControl();
    }

    async checkScheduleLimit() {
        let status = true;
        if (this.enterprise.qtdAgendaPaciente > 0) {
            const result = await this.scheduleService.checkScheduleLimit(
                this.paciente.id
            );
            if (!result.status) {
                this.snackBar.warnMessage(
                    `Limite de Agendamento OnLine Alcançado (Máximo ${result.limit} )`
                );
                status = false;
                return;
            }
        }
        status
            ? (this.newSchedule = !this.newSchedule)
            : (this.newSchedule = status);
    }

    async searchProfessional(especialidade: any) {
        if ((this.showProfessional = "1")) {
            if (especialidade.idEspecialidade) {
                const speciality = this.specialityControl.value;
                this.professionalEspecialidade = [];
                this.professionalList.forEach((element) => {
                    element.especialidades.forEach((element1) => {
                        if (
                            element1.idEspecialidade ===
                            speciality.idEspecialidade
                        ) {
                            this.professionalEspecialidade.push({ element });
                        }
                    });
                });
                this.professionalControl.setValue("");
            }
        }
    }

    async getList() {
        this.getSCheduleList();
        await this.getInsurance();
        await this.getUnity();
        await this.getSpecially();
    }

    getSCheduleList(event?, type?) {
        this.progressBar.show();

        switch (type) {
            case "short":
                this.schedulePageOptions.fieldSort = event.active;
                this.schedulePageOptions.sortDirection = event.direction;
                break;
            case "page":
                this.schedulePageOptions.page = event.pageIndex;
                this.schedulePageOptions.sizePage = event.pageSize;
                break;

            default:
                this.schedulePageOptions.page = 0;
                this.schedulePageOptions.sizePage = 10;
                break;
        }

        this.scheduleService
            .getScheduleList(this.paciente.id, "F", this.schedulePageOptions)
            .then((res) => {
                this.dataSource = res.body.content;
                this.totalElements = res.body.totalElements;
                this.pagina = res.body.number;
                this.progressBar.hide();
            });
    }

    getSCheduleHistoryList(event?, type?) {
        this.progressBar.show();

        switch (type) {
            case "short":
                this.schedulePageOptions.fieldSort = event.active;
                this.schedulePageOptions.sortDirection = event.direction;
                break;
            case "page":
                this.schedulePageOptions.page = event.pageIndex;
                this.schedulePageOptions.sizePage = event.pageSize;
                break;

            default:
                this.schedulePageOptions.page = 0;
                this.schedulePageOptions.sizePage = 10;
                break;
        }

        this.scheduleService
            .getScheduleList(this.paciente.id, "A", this.schedulePageOptions)
            .then((res) => {
                this.dataSource = res.body.content;
                this.totalElements = res.body.totalElements;
                this.pagina = res.body.number;
                this.progressBar.hide();
            });
    }

    async onTabChange(index: number) {
        switch (index) {
            case 0:
                this.getSCheduleList();
                break;
            case 1:
                this.getSCheduleHistoryList();
                break;
            default:
                break;
        }
    }
    /* setDefaultInsurance() {
        const patient = JSON.parse(localStorage.getItem("paciente"));
        const patientInsurance = this.insuranceList.find(
            (insurance) => insurance.id == patient.idConvenio
        );

        if (!patientInsurance) {
            this.snackBar.warnMessage(
                `Caso não seja possível a marcação, entrar em contato com a clínica através do telefone ${
                    this.enterprise ? this.enterprise.telefone : ""
                }`
            );
        }else{
            this.insuranceControl.setValue(patientInsurance);
            this.getProcedure();
        }
        
       
        return patientInsurance;
    }*/

    async getProcedure() {
        if (!this.insuranceControl.value?.id || !this.unityValue?.id) {
            this.procedureList = [];
            return;
        }

        await this.scheduleService
            .getProcedureByInsuranceAndPerformer(
                this.insuranceControl.value.id,
                this.professionalControl.value?.performerId,
                this.unityValue.id,
                this.procedurePageOptions
            )
            .then((res) => {
                console.log(res);
                this.procedureList = res.body.content;

                if (this.procedureList.length <= 0) {
                    this.snackBar.warnMessage(
                        "Profissional não atende serviços para o convênio selecionado!"
                    );
                }
            });
    }

    async getUnity() {
        await this.scheduleService.getUnityList().then((res: any) => {
            this.unitList = res;
            this.unityValue = this.unitList[0];
        });
    }

    async getInsuranceById(id: number) {
        await this.scheduleService.getInsuranceById(id).then((res: any) => {
            console.log(res);
            this.insuranceControl.setValue(res.body);
        });
    }

    async getSpecially(filter?: string) {
        if (!this.unityValue?.id) {
            this.specialityList = [];
            return;
        }

        const companyId = this.unityValue.id;
        this.specialityPageOptions.fieldSort = "name";
        this.specialityPageOptions.sortDirection = "asc";
        await this.scheduleService
            .getSpecialistyPageSimpleList(this.specialityPageOptions, companyId)
            .then((res) => {
                if (this.unityValue?.id !== companyId) return;
                this.specialityList = res.body.content;
            });
    }

    // carrega lista de Convenios
    async getInsurance(filter?: string) {
        await this.scheduleService
            .getInsurancePageSimpleList(this.insurancePageOptions)
            .then((res) => {
                this.insuranceList = res.body.content;
            });
    }

    async getScheduleDates() {
        if (!this.professionalControl.value?.performerId || !this.unityValue?.id) {
            this.dateList = [];
            return;
        }

        await this.scheduleService
            .findScheduleDates(
                this.professionalControl.value.performerId,
                this.unityValue.id
            )
            .then((res) => {
                this.dateList = res;
            });
    }

    async getScheduleHours(date: any) {
        if (!this.professionalControl.value?.performerId || !this.unityValue?.id || !date) {
            this.hourList = [];
            return;
        }

        await this.scheduleService
            .findScheduleHours(
                this.professionalControl.value.performerId,
                this.unityValue.id,
                date
            )
            .then((res) => {
                this.hourList = res;
            });
    }

    async getProfessional(filter?: string) {
        if (!this.specialityControl.value?.id || !this.unityValue?.id || !this.insuranceControl.value?.id) {
            this.professionalList = [];
            return;
        }

        this.performerPageOptions.fieldSort = "professional.person.name";
        await this.scheduleService
            .getPerformerAllPageNoEntity(
                this.performerPageOptions,
                this.specialityControl.value.id,
                this.unityValue.id,
                this.insuranceControl.value.id
            )
            .then((res) => {
                this.professionalList = res.body.content;
            });
    }

    getCurrentDate() {
        var d = new Date(),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");
    }

    observableSpeciality() {
        this.specialityControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(600),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                if (res && res.name) {
                    this.specialityPageOptions.argument = "";
                    this.getProfessional();
                } else if (res && typeof res === "string") {
                    this.specialityPageOptions.argument = res;
                    this.professionalControl.setValue(null);
                } else {
                    this.specialityPageOptions.argument = "";
                    this.professionalControl.setValue(null);
                }
                this.getSpecially();
            });
    }

    observableInsurance() {
        this.insuranceControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                if (res && res.name) {
                    this.getProfessional();
                    this.getProcedure();
                } else if (res) {
                    this.insurancePageOptions.argument = res;
                } else {
                    this.insurancePageOptions.argument = "";
                }
                this.getInsurance();
            });
    }

    observableProfessional() {
        this.professionalControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                if (res && res.performerName) {
                } else if (res) {
                    this.performerPageOptions.argument = res;
                    this.getProfessional();
                } else {
                    this.performerPageOptions.argument = "";
                    this.getProfessional();
                }
            });
    }

    observableDateControl() {
        this.dateControl.valueChanges.subscribe((res) => {
            if (res && res.date) {
                console.log(
                    "🚀 ~ ScheduleComponent ~ this.dateControl.valueChanges.subscribe ~ res:",
                    res
                );
                this.getScheduleHours(res.date);
            }
        });
    }
    observableProcedure() {
        this.procedureControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                if (res && res.name) {
                    if (res.preparation) {
                        this.prepareProcedureControl.setValue(res.preparation);
                    }

                    this.getScheduleDates();
                } else if (res) {
                    this.procedurePageOptions.argument = res;
                    this.getProcedure();
                } else {
                    this.procedurePageOptions.argument = "";
                    this.getProcedure();
                }
            });
    }

    observableHourControl() {
        this.hourControl.valueChanges.subscribe((schedule) => {
            this.schedule = schedule;
        });
    }

    async searchAvailability() {
        if (!this.checkFields()) return;
        if (this.showProfessional == "1") {
            this.searchScheduleProfessional();
        } else {
            const unity = this.unityValue;
            const speciality = this.specialityControl.value;
            this.progressBar.show();
            this.scheduleService
                .consultaAgendamentoPorUnidadeEspecialidade(
                    unity.idUnidade,
                    speciality.idEspecialidade
                )
                .then((res: any) => {
                    if (!res.length) {
                        this.progressBar.hide();
                        this.handleWaitingList();
                        return;
                    }
                    if (res.horarios) {
                        this.scheduleList = new Array();
                        new Date() >=
                        new Date(res.dataAgenda + "T23:59:59-03:00")
                            ? this.scheduleList.push(res)
                            : (this.scheduleList = []);
                    } else {
                        this.scheduleList = res.filter(
                            (schedule) =>
                                new Date(
                                    schedule.dataAgenda + "T23:59:59-03:00"
                                ) >= new Date()
                        );
                    }
                    this.progressBar.hide();
                    this.dateControl.setValue(null, { emitEvent: false });
                    this.hourControl.setValue(null, { emitEvent: false });
                    this.dateControl.markAsUntouched();
                    this.hourControl.markAsUntouched();
                })
                .catch((err) => {
                    this.progressBar.hide();
                });
        }
    }
    async searchScheduleProfessional() {
        if (this.professionalControl.value) {
            const profissional = this.professionalControl.value;

            const unity = this.unityValue;

            const speciality = this.specialityControl.value;

            this.progressBar.show();
            this.unregisteredSscheduleService
                .consultaAgendamentoPorUnidadeEspecialidadeProfissional(
                    unity.idUnidade,
                    speciality.idEspecialidade,
                    profissional.idProfissional
                )
                .then((res: any) => {
                    if (res.horarios) {
                        this.scheduleList = new Array();
                        new Date(res.dataAgenda) >= new Date()
                            ? this.scheduleList.push(res)
                            : (this.scheduleList = []);
                    } else {
                        this.scheduleList = res.filter(
                            (schedule) =>
                                new Date(schedule.dataAgenda) >= new Date()
                        );
                    }
                    this.progressBar.hide();
                    this.dateControl.setValue(null, { emitEvent: false });
                    this.hourControl.setValue(null, { emitEvent: false });
                    this.dateControl.markAsUntouched();
                    this.hourControl.markAsUntouched();

                    if (!res.length) {
                        this.snackBar.warnMessage(
                            "Agenda não disponível para médico."
                        );
                        this.progressBar.hide();
                        this.handleWaitingList();
                    }
                })
                .catch((err) => {
                    this.progressBar.hide();
                });
        }
    }

    async saveSchedule(procedureId: number, item: any) {
        this.progressBar.show();
        let schedule = new Schedule();
        schedule.scheduleId = item.id;
        schedule.patientId = JSON.parse(
            localStorage.getItem("paciente")
        ).idPaciente;
        schedule.procedureId = procedureId;
        schedule.insuranceId = this.insuranceControl.value.id;

        this.scheduleService
            .saveSchedule(schedule)
            .then((res) => {
                this.getSCheduleList();
                this.scheduleService.unregisterScheduleUsage(item.id);
                this.snackBar.successMessage(res.message);
                this.newSchedule = false;
                this.progressBar.hide();
            })
            .catch((err) => {
                this.scheduleService.unregisterScheduleUsage(item.id);
                this.progressBar.hide();
            });

        console.log(schedule);
    }

    waitingListRegistration() {
        moment.locale("pt-br");
        const waitingListRegistration = {
            idUnidade: this.unityValue.idUnidade,
            idProfissional: this.professionalControl.value
                ? this.professionalControl.value.idProfissional
                : this.professionalList[0].idProfissional,
            idConvenio: this.insuranceControl.value.idConvenio,
            idEspecialidade: this.specialityControl.value.idEspecialidade,
            idProcedimento: this.procedureControl.value.idProcedimento,
            nomeProcedimento: this.procedureControl.value.nomeProcedimento,
            grupoProcedimento: this.procedureControl.value.grupoProcedimento,
            idPaciente: this.paciente.idPaciente,
            nomePaciente: this.paciente.nomePaciente,
            telefone: this.paciente.telefoneCelular,
            nomeUsuarioMarcou: "Agenda OnLine Paciente",
            dataAgenda: moment().format("YYYY-MM-DD"),
            horaAgenda: moment().format("LTS"),
            situacaoAgenda: "S",
            observacao: this.observableControl.value || null,
            retirouLista: null,
            dataRetirouLista: null,
            usuarioRetirouLista: null,
        };
    }

    async verificaIdade(professional, patientId) {
        try {
            const patient = await this.profileService.buscar(patientId);
            const idadePaciente = this.validarIdade(patient.dataNascimento);

            if (
                idadePaciente >= professional.idadeMinima &&
                idadePaciente <= professional.idadeMaxima
            ) {
                return true;
            } else if (
                professional.idadeMinima == null &&
                professional.idadeMaxima == null
            ) {
                return true;
            } else {
                return false;
            }
        } catch (error) {}
    }
    validarIdade(data: any) {
        const dataNascimento = moment(data);
        moment.locale("pt");
        const diaNascimento = moment(dataNascimento).format("DD");
        const mesNascimento = moment(dataNascimento).format("MM");
        const anoNascimento = moment(dataNascimento).format("YYYY");

        const diaAtual = moment().format("DD");
        const mesAtual = moment().format("MM");
        const anoAtual = moment().format("YYYY");

        let idade = Number(anoAtual) - Number(anoNascimento);

        if (
            mesAtual < mesNascimento ||
            (mesAtual == mesNascimento && diaAtual < diaNascimento)
        ) {
            idade--;
        }
        return idade;
    }

    async handleWaitingList() {
        const dialogRef = this._matDialog.open(WaitingListComponent);

        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.waitingListRegistration();
                }
            },
        });
    }

    checkFields() {
        let valid = true;
        if (!this.unityValue?.id) {
            this.snackBar.warnMessage("Campo unidade é obrigatório.");
            valid = false;
        } else if (!this.specialityControl.value?.id) {
            this.snackBar.warnMessage("Campo especialidade é obrigatório.");
            this.specialityControl.markAsTouched();
            valid = false;
        } else if (!this.insuranceControl.value?.id) {
            this.snackBar.warnMessage("Campo convênio é obrigatório.");
            this.insuranceControl.markAsTouched();
            valid = false;
        }
        return valid;
    }

    displayFnSpeciality(obj?: any): string {
        if (obj) {
            if (typeof obj === "string") {
                return obj;
            }
            if (!obj.name) {
                return null;
            }
            return obj.name;
        }
        return null;
    }

    displayFnInsurance(obj?: any): string {
        if (obj) {
            if (typeof obj === "string") {
                return obj;
            }
            if (!obj.name) {
                return null;
            }
            return obj.name;
        }
        return null;
    }

    displayFnProfessional(performer?: any): string {
        console.log(
            "🚀 ~ ScheduleComponent ~ displayFnProfessional ~ performer:",
            performer
        );
        if (!performer) {
            return "";
        }
        if (typeof performer === "string") {
            return performer;
        }
        if (performer.performerName) {
            return performer.performerName;
        }
        return performer.person?.name || "";
    }

    displayFnProcedure(obj?: any): string {
        if (obj) {
            if (typeof obj === "string") {
                return obj;
            }
            if (!obj.name) {
                return null;
            }
            return obj.name;
        }
        return null;
    }

    getScheduleeList(qtd?: number) {
        if (!this.checkFields() || this.loadingSchedule) return;

        const companyId = this.unityValue.id;
        this.loadingSchedule = true; // inicia o loading
        this.scrollToSchedules();

        this.schedulePageOptions.sizePage = 50;

        if (qtd) {
            this.qtdScheduleList += qtd;
            this.schedulePageOptions.sizePage =
                this.qtdScheduleList + this.schedulePageOptions.sizePage;
        }

        this.scheduleService
            .getSchedulePageSimpleList(
                this.schedulePageOptions,
                this.professionalControl.value?.performerId,
                companyId,
                this.specialityControl.value?.id,
                this.insuranceControl.value?.id
            )
            .then((res) => {
                if (this.unityValue?.id !== companyId) return;
                this.scheduleList = res.body.content || [];

                if (this.scheduleList.length <= 0) {
                    this.groupedSchedules = [];
                    this.snackBar.warnMessage(
                        "Nenhum horário disponível para os filtros selecionados."
                    );
                    return;
                }

                this.groupSchedulesByDate();
            })
            .catch((err) => {
                console.error(err);
                this.snackBar.errorMessage("Erro ao buscar agenda");
            })
            .finally(() => {
                this.loadingSchedule = false; // encerra o loading, sucesso ou erro
                this.scrollToSchedules();
            });
    }

    private groupSchedulesByDate(): void {
        const groupedByDate: Record<string, any> = {};

        this.scheduleList.forEach((item) => {
            if (!groupedByDate[item.date]) {
                groupedByDate[item.date] = {};
            }

            if (!groupedByDate[item.date][item.performerId]) {
                groupedByDate[item.date][item.performerId] = {
                    performerId: item.performerId,
                    performerName: item.performerName,
                    specialityName: item.specialityName,
                    hours: [],
                };
            }

            groupedByDate[item.date][item.performerId].hours.push(item);
        });

        this.groupedSchedules = Object.keys(groupedByDate).map((date) => ({
            date,
            performers: Object.values(groupedByDate[date]),
        }));

    }

    private scrollToSchedules(): void {
        [0, 100, 300].forEach((delay) => {
            setTimeout(() => {
                window.requestAnimationFrame(() => this.forceScheduleScroll());
            }, delay);
        });
    }

    private forceScheduleScroll(): void {
        const target = this.scheduleContainer?.nativeElement as HTMLElement;
        if (!target) return;

        target.scrollIntoView({ block: "start", inline: "nearest" });

        let parent = target.parentElement;
        let internalScrollApplied = false;
        while (parent) {
            const overflowY = window.getComputedStyle(parent).overflowY;
            const canScroll = /auto|scroll|hidden|overlay/.test(overflowY);

            if (canScroll && parent.scrollHeight > parent.clientHeight) {
                const targetRect = target.getBoundingClientRect();
                const parentRect = parent.getBoundingClientRect();
                const top =
                    parent.scrollTop + targetRect.top - parentRect.top - 12;

                parent.scrollTop = Math.max(0, top);
                internalScrollApplied = true;
            }

            parent = parent.parentElement;
        }

        if (!internalScrollApplied) {
            const top =
                target.getBoundingClientRect().top + window.pageYOffset - 12;
            window.scrollTo(0, Math.max(0, top));
        }
    }

    handleSchedule(item: any) {
        this.scheduleService
            .registerScheduleUsage(item.id)
            .then((res) => {
                const dialogRef = this._matDialog.open(
                    SelectProcedureComponent,
                    {
                        width: "80%",
                        maxWidth: "95vw",
                        panelClass: "no-padding-dialog",
                        autoFocus: false,
                        data: {
                            insuranceId: this.insuranceControl?.value?.id,
                            performerId: item.performerId,
                            companyId: this.unityValue.id,
                            companyName: this.unityValue.tradeName,
                            schedule: item,
                        },
                    }
                );

                dialogRef.afterClosed().subscribe((result) => {
                    console.log(`Dialog result: ${result}`);
                    if (!result?.id) {
                        this.scheduleService.unregisterScheduleUsage(item.id);
                        return;
                    }

                    let procedureId = result.id;

                    this.confirmDialogRef = this._matDialog.open(
                        FuseConfirmDialogComponent,
                        {
                            disableClose: false,
                        }
                    );
                    this.confirmDialogRef.componentInstance.confirmMessage =
                        "Deseja confirmar o agendamento?";
                    this.confirmDialogRef.componentInstance.confirmTitle =
                        "Confirmação";
                    this.confirmDialogRef.afterClosed().subscribe((confirmed) => {
                        if (confirmed) {
                            this.saveSchedule(procedureId, item);
                        } else {
                            this.scheduleService.unregisterScheduleUsage(item.id);
                        }
                        this.confirmDialogRef = null;
                    });
                });
            })
            .catch((err) => {});
    }
}
